import TextField from "@mui/material/TextField";
import { Upload } from "@mui/icons-material";
import { listArts } from "../../../../services/arts";
import { RequestArtParams } from "../../../../types/arts";
import { isEmpty, map } from "lodash";
import Grid from "@mui/system/Unstable_Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { addDays, subMonths } from "date-fns";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { ArtImage } from "../../../../components/ArtImage";
import Stack from "@mui/material/Stack";

import { Arts as TArts } from "../../../../types/arts";
import { ButtonFile } from "../../../../components/ButtonFile";

type ArtsProps = {
  onSelect: (data: TArts) => void;
  onUpload: (file: File) => void;
  uploading?: boolean;
};

export default function Arts({ uploading, onSelect, onUpload }: ArtsProps) {
  const [artName, setArtName] = useState<string>();

  const rangeDate = useMemo(() => {
    return {
      endDate: addDays(new Date(), 1),
      startDate: subMonths(new Date(), 1),
    };
  }, []);

  const arts = useQuery(["arts", artName], () => {
    const params: RequestArtParams = {
      endDate: rangeDate.endDate,
      startDate: rangeDate.startDate,
      name: artName,
    };

    return listArts(params);
  });

  const handleSelectedArt = useCallback(
    (art) => {
      if (!uploading) {
        onSelect(art);
      }
    },
    [uploading, onSelect]
  );

  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row">
        <TextField
          disabled={uploading}
          label="Pesquisar por nome"
          size="small"
          onChange={({ target: { value } }) => {
            setArtName(value);
          }}
        />
        <ButtonFile
          loading={uploading}
          icon={<Upload />}
          disabled={arts.isLoading}
          onChange={onUpload}
        />
      </Stack>

      <Grid container spacing={2}>
        {arts.isLoading ? (
          <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
            <CircularProgress />
          </Grid>
        ) : isEmpty(arts.data) ? (
          <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
            <Typography color="GrayText">Lista de artes vazia.</Typography>
          </Grid>
        ) : (
          map(arts.data, (art, index) => (
            <Grid xs={2} key={index}>
              <ArtImage
                onClick={() => {
                  handleSelectedArt(art);
                }}
                image={art.artes[0]?.miniatura || art.artes[0]?.link}
                name={art.nome_tabloide_digital}
              />
            </Grid>
          ))
        )}
      </Grid>
    </Stack>
  );
}
